import { Injectable } from '@angular/core';
import {
  DEFAULT_MAX_ZOOM_LEVEL,
  DEFAULT_MIN_ZOOM_LEVEL,
  GOOGLE_MAP_STYLES
} from '@constants/google-maps/google-maps.constant';
import { LocationDetails } from '@models/locationDetails/location-details';

@Injectable({
  providedIn: 'root'
})
export class WidgetHelperService {

  public mapOptionsInit(center: google.maps.LatLng | undefined): google.maps.MapOptions {
    return {
      center,
      mapTypeControl: false,
      draggable: false,
      fullscreenControl: false,
      panControl: false,
      streetViewControl: false,
      keyboardShortcuts: false,
      rotateControl: false,
      maxZoom: DEFAULT_MAX_ZOOM_LEVEL,
      minZoom: DEFAULT_MIN_ZOOM_LEVEL,
      styles: GOOGLE_MAP_STYLES
    };
  }

  public markerInit(position: google.maps.LatLng | undefined, title): google.maps.Marker {
    return new google.maps.Marker({
      position: position,
      title,
    });
  }

  public setMarkerOptions(mapType): google.maps.MarkerOptions {
    const url = 'assets/img/common/map/';
    const icon: google.maps.Icon = {
      url: url + (mapType === 'roadmap' ? 'map_pin_dark.svg' : 'map_pin_light.svg'),
      scaledSize: {
        height: 45,
        width: 45,
        equals: () => true
      },
    };
    return {
      icon,
      animation: google.maps.Animation.DROP, // or .BOUNCE
    };
  }

  public getMachineAddress(locationDetails: LocationDetails): string {
    const {street, number, postalCode, regionCity, country} = locationDetails;
    // compare street and number
    let firstPart = `${street || ''} ${number || ''}`;
    if (street || number) {
      firstPart += ', \n';
    }
    // compare postalCode and regionCity
    let secondPart = `${postalCode || ''} ${regionCity || ''}`;
    if (postalCode || regionCity) {
      secondPart += ', \n';
    }

    return (firstPart || '') + (secondPart || '') + (country || '');
  }
}
